import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { CURRENT_VERSION } from "../shared/constants";
import { getUsername, getPlanSlug, getTimestamp } from "../shared/utils";

export default class Storage extends AbstractProvidedClass {
    constructor(provider) {
        super(provider);

        this.basePath = `plans.${getUsername(this.p)}.${getPlanSlug(this.p)}`;
    }

    get() {
        let data = this.p.getItem(this.basePath)
        if (data) {
            return data;
        }
        let view = this.view;
        let settings = this.settings;
        let plants = this.plants;
        let shapes = this.shapes;
        let timestamp = this.p.max([
            view.timestamp ?? 0,
            settings.timestamp ?? 0,
            plants.timestamp ?? 0,
            shapes.timestamp ?? 0,
        ]);
        return timestamp == 0
            ? null
            : {
                view: view,
                settings: settings,
                plants: plants.plants,
                species: plants.species,
                shapes: shapes.shapes,
                timestamp: timestamp,
                version: 0,
            }
    }

    save() {
        if (!this.loaded || (this.image && !this.image._loaded)) {
            return;
        }
        this.emptyLegacy();
        let data = {
            name: this.provider.planName,
            view: this.provider.view.export(),
            settings: this.provider.settings.export(),
            elements: this.provider.elements.export(),
            species: this.provider.speciesCollection.collection,
            image: this.provider.image?.export(),
            timestamp: getTimestamp(),
            version: CURRENT_VERSION,
        };
        data.settings.access = this.provider.settings.access;
        data.settings.name = this.provider.settings.name;
        this.p.storeItem(this.basePath, data);
    }

    empty() {
        this.p.removeItem(this.basePath);
    }

    emptyLegacy() {
        this.p.removeItem(this.viewPath);
        this.p.removeItem(this.settingsPath);
        this.p.removeItem(this.plantsPath);
        this.p.removeItem(this.shapesPath);
    }

    get view() {
        return this.p.getItem(this.viewPath) ?? {};
    }

    set view(view) {
        return this.save();
    }

    get settings() {
        return this.p.getItem(this.settingsPath) ?? {};
    }

    set settings(settings) {
        return this.save();
    }

    get plants() {
        let plants = this.p.getItem(this.plantsPath);
        if (plants) {
            this.provider.changesMade(true);
        }
        return plants ?? {};
    }

    set plants(plants) {
        return this.save();
    }

    get shapes() {
        let shapes = this.p.getItem(this.shapesPath);
        if (shapes) {
            this.provider.changesMade(true);
        }
        return shapes ?? {};
    }

    set shapes(shapes) {
        return this.save();
    }

    get viewPath() {
        return `${this.basePath}.view`;
    }

    get settingsPath() {
        return `${this.basePath}.settings`;
    }

    get plantsPath() {
        return `${this.basePath}.plants`;
    }

    get shapesPath() {
        return `${this.basePath}.shapes`;
    }
}
